module.exports = __webpack_public_path__ + "static/media/Amatic Bold.02d75a77.svg";